<template>
  <div id="unsubscription">
    <h2>プレミアム退会</h2>
    <hr>
    <div v-show="loading" class="lds-roller"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div>
    <div v-show="result">
      <div v-show="success">
        <p>退会に成功しました(;O;)</p>
        <p>5秒後にTOPページへ移動します</p>
      </div>
      <div v-show="!success">
        <p class="has-text-danger">退会に失敗しました。問い合わせからご連絡ください。</p>
      </div>
    </div>
    <div v-show="!loading && main">
      <p>ご利用いただきありがとうございました。<br>
        今までアップロードしたファイルは今後も利用可能です。</p>
      <br>
      <button @click="exec" class="button is-primary">退会する</button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'UnSubscription',
  data () {
    return {
      main: true,
      loading: false,
      result: false,
      success: false
    }
  },
  methods: {
    exec: function () {
      this.main = false
      this.loading = true

      this.$axios.get(this.baseURL + '/unsubscription', { withCredentials: true })
        .then(response => {
          this.loading = false
          this.result = true
          this.success = true

          function top () {
            location.href = '/'
          }
          setTimeout(top, 5000)
        }).catch(() => {
          this.loading = false
          this.result = true
        })
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/UnSubscription.vue